module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_hire","prefix":"about_hire"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/in/setting/about/setting.json
// module id = 638
// module chunks = 0 1 2 3 4 5